// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  padding-bottom: 15px;
}

@media (min-width: 768px) {
  .row {
    display: flex;
    gap: 15px;
    flex: 1;
    margin-bottom: 15px;
  }
  .empty-column {
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex: 1 100%;
  }
}
@media (max-width: 768px) {
  .row {
    display: flex;
    gap: 15px;
    flex: 1;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }
  .empty-column {
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex: 0 0%;
  }
}
.no-gap-row {
  display: flex;
  flex: 1;
  -moz-column-gap: 15px;
       column-gap: 15px;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1 100%;
}

.no-gap-column {
  display: flex;
  flex-direction: column;
  flex: 1 100%;
}

.color-grayblue {
  color: #324758;
}

.reload-button-container {
  display: flex;
  justify-content: flex-end;
}
.reload-button-container .reload-button {
  width: 220px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/intern/obs-assessment/obs-summary/obs-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;AACJ;;AAEA;EACI;IACI,aAAA;IACA,SAAA;IACA,OAAA;IACA,mBAAA;EACN;EAEE;IACI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,YAAA;EAAN;AACF;AAGA;EACI;IACI,aAAA;IACA,SAAA;IACA,OAAA;IACA,mBAAA;IACA,eAAA;EADN;EAIE;IACI,aAAA;IACA,sBAAA;IACA,SAAA;IACA,UAAA;EAFN;AACF;AAKA;EACI,aAAA;EACA,OAAA;EACA,qBAAA;OAAA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAHJ;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,aAAA;EACA,yBAAA;AAHJ;AAKI;EACI,uBAAA;AAHR","sourcesContent":[".header {\n    padding-bottom: 15px;\n}\n\n@media (min-width: 768px) {\n    .row {\n        display: flex;\n        gap: 15px;\n        flex: 1;\n        margin-bottom: 15px;\n    }\n\n    .empty-column {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        flex: 1 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .row {\n        display: flex;\n        gap: 15px;\n        flex: 1;\n        margin-bottom: 15px;\n        flex-wrap: wrap;\n    }\n\n    .empty-column {\n        display: flex;\n        flex-direction: column;\n        gap: 15px;\n        flex: 0 0%;\n    }\n}\n\n.no-gap-row {\n    display: flex;\n    flex: 1;\n    column-gap: 15px;\n}\n\n.column {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    flex: 1 100%;\n}\n\n.no-gap-column {\n    display: flex;\n    flex-direction: column;\n    flex: 1 100%;\n}\n\n.color-grayblue {\n    color: #324758;\n}\n\n.reload-button-container {\n    display: flex;\n    justify-content: flex-end;\n\n    .reload-button {\n        width: 220px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
